import { cn } from '../../../utils/cn';
import styles from './Avatar.module.css';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps {
  name: string;
  src?: string;
  size?: AvatarSize;
  className?: string;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return (parts[0] ?? '').slice(0, 2);
  return ((parts[0] ?? '').charAt(0) + (parts[parts.length - 1] ?? '').charAt(0));
}

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  return (
    <span
      className={cn(styles.avatar, styles[size], className)}
      role="img"
      aria-label={name}
      title={name}
    >
      {src ? (
        <img className={styles.image} src={src} alt="" />
      ) : (
        <span aria-hidden>{initials(name)}</span>
      )}
    </span>
  );
}
